<template>
  <el-dialog
    v-loading="dialogLoading"
    title="Tạo OOO/OOS"
    visible
    append-to-body
    :close-on-click-modal="false"
    width="600px"
    class="body-overflow__visible"
    @close="onClose"
  >
    <validation-observer ref="ooFormValidator">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <validation-provider rules="required" :name="$t('field.type')">
                <div class="das-form-input">
                  <div class="label required">{{ $t('field.type') }}</div>
                  <el-select v-model="formData.type" placeholder="">
                    <el-option
                      v-for="item in roomTypeOptions"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                  <!-- <div class="child-w-80">
                      <select v-model="formData.type">
                        <option value="1">Phòng ngừng sử dụng</option>
                        <option value="2">Phòng không phục vụ</option>
                      </select>
                    </div> -->
                </div>
              </validation-provider>
            </div>
            <div class="das-form-col col-6">
              <validation-provider
                rules="required"
                :name="$t('field.returnStatus')"
              >
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.returnStatus') }}
                  </div>
                  <el-select v-model="formData.status" placeholder="">
                    <el-option
                      v-for="item in roomStatusOptions"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                  <!-- <div class="child-w-80">
                      <select v-model="formData.status">
                        <option value="1">Sạch</option>
                        <option value="2">Bẩn</option>
                        <option value="3">Đã kiểm tra</option>
                      </select>
                    </div> -->
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.fromDate') }}
                </div>
                <div class="child-w-80">
                  <validation-provider
                    rules="required"
                    :name="$t('field.fromDate')"
                  >
                    <CalendarSelect
                      v-model="formData.date_from"
                      mode="date"
                      :min-max="{
                        min: $moment().format('YYYY-MM-DD')
                      }"
                      @input="onChangeDateFrom"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.toDate') }}
                </div>
                <div class="child-w-80">
                  <validation-provider
                    rules="required"
                    :name="$t('field.toDate')"
                  >
                    <CalendarSelect
                      v-model="formData.date_to"
                      mode="date"
                      :min-max="{
                        min: $moment().format('YYYY-MM-DD')
                      }"
                      @input="onChangeDateTo"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col w-100">
              <validation-provider rules="required" :name="$t('field.reason')">
                <div class="das-form-input">
                  <div class="label required">{{ $t('field.reason') }}</div>
                  <div class="child-w-80">
                    <textarea v-model="formData.reason" />
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small outline" @click="onClose">
          {{ $t('button.cancel') }}
        </button>
        <button class="btn primary small" @click="fnSubmitAddForm">
          {{ $t('button.add') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import {
  // eslint-disable-next-line no-unused-vars
  addOooRoomApi
} from '@/api/houseKeeper/ooo-room'
import { roomInfo } from '../stores'

export default {
  components: {
    CalendarSelect
  },
  props: {
    isShow: {
      handler(val) {
        if (!val) {
          this.formData = {
            room_id: null,
            type: 0,
            status: 1,
            date_from: null,
            date_to: null,
            reason: 1
          }
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      dialogLoading: false,
      formData: {
        room_id: null,
        type: 0,
        status: 1,
        date_from: null,
        date_to: null,
        reason: 1
      },
      roomStatusOptions: [
        {
          label: 'Sạch',
          value: 1
        },
        {
          label: 'Bẩn',
          value: 2
        }
      ],
      roomTypeOptions: [
        {
          label: 'Phòng ngừng sử dụng',
          value: 0
        },
        {
          label: 'Phòng không phục vụ',
          value: 1
        }
      ],
      roomInfo
    }
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.formData.date_from = date
      if (!this.checkValidDateRange(date, this.formData.date_to)) {
        setTimeout(() => {
          this.formData.date_to = null
        })
      }
    },

    onChangeDateTo(date) {
      this.formData.date_to = date
      if (!this.checkValidDateRange(this.formData.date_from, date)) {
        setTimeout(() => {
          this.formData.date_to = null
        })
      }
    },

    async fnSubmitAddForm() {
      if ((await this.$vxForm.isValid(this.$refs.ooFormValidator)) === false) {
        return
      }
      const queryParams = {
        roomIdList: [this.roomInfo.room_id]
      }
      addOooRoomApi(queryParams, this.formData)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t(`${'successMsg.' + res.message}`)
          })
          this.$emit('resetData')
          this.$emit('close')
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style></style>
